export class Company {
  [index: string]: unknown
  id?: string
  name: string
  slug?: string
  company_type: string
  managers: Array<CompanyManager['id']>
  ma_niem_yet: string
  von_dieu_le: number | null
  von_dieu_le_tong_cong_ty: number | null
  von_dieu_le_don_vi: number | null

  constructor (company?: Company) {
    this.id = company?.id
    this.name = company?.name || ''
    this.slug = company?.slug
    this.company_type = company?.company_type || ''
    this.managers = company?.managers || []
    this.ma_niem_yet = company?.ma_niem_yet || ''
    this.von_dieu_le = company?.von_dieu_le || null
    this.von_dieu_le_tong_cong_ty = company?.von_dieu_le_tong_cong_ty || null
    this.von_dieu_le_don_vi = company?.von_dieu_le_don_vi || null
    this.nguoi_dai_dien = company?.nguoi_dai_dien || ''
    this.chuc_vu_nguoi_dai_dien = company?.chuc_vu_nguoi_dai_dien || ''
  }
}


export class CompanyManager {
  [index: string]: unknown
  id?: string
  name: string
  role: string
  company: Company['id']

  constructor (manager?: CompanyManager) {
    this.id = manager?.id
    this.name = manager?.name || ''
    this.role = manager?.role || ''
    this.company = manager?.company || undefined
  }
}


export class FinanceInfo {
  [index: string]: unknown
  id?: string
  company: Company['id'] | Company
  year: number
  doanh_thu_ke_hoach?: number | null
  doanh_thu_cong_ich_ke_hoach?: number | null
  doanh_thu_cong_ich_thuc_hien?: number | null
  doanh_thu_ngoai_cong_ich_ke_hoach?: number | null
  doanh_thu_ngoai_cong_ich_thuc_hien?: number | null
  doanh_thu_tai_chinh?: number | null
  thu_nhap_khac?: number | null
  tai_san_ngan_han?: number | null
  no_ngan_han?: number | null
  no_dai_han?: number | null
  von_gop_CSH_ke_hoach?: number | null
  von_gop_CSH_dau_nam?: number | null
  quy_dtpt_dau_nam?: number | null
  von_gop_CSH_thuc_hien_dau_nam?: number | null
  von_gop_CSH_cuoi_nam?: number | null
  quy_dtpt_cuoi_nam?: number | null
  von_gop_CSH_thuc_hien_cuoi_nam?: number | null
  co_tuc_ke_hoach_tong_cong_ty?: number | null
  co_tuc_thuc_hien_tong_cong_ty?: number | null
  ty_le_co_tuc_ke_hoach_tong_cong_ty?: number | null
  ty_le_co_tuc_thuc_hien_tong_cong_ty?: number | null
  co_tuc_ke_hoach_don_vi?: number | null
  co_tuc_thuc_hien_don_vi?: number | null
  ty_le_co_tuc_ke_hoach_don_vi?: number | null
  ty_le_co_tuc_thuc_hien_don_vi?: number | null
  loi_nhuan_sau_thue_ke_hoach?: number | null
  loi_nhuan_sau_thue_thuc_hien?: number | null
  tien_luong_nguoi_quan_ly_ke_hoach?: number | null
  tien_luong_nguoi_quan_ly_thuc_hien?: number | null
  tien_luong_nguoi_lao_dong_ke_hoach?: number | null
  tien_luong_nguoi_lao_dong_thuc_hien?: number | null

  constructor (financeInfo?: FinanceInfo) {
    this.id = financeInfo?.id
    this.company = financeInfo?.company
    this.year = financeInfo?.year || new Date().getFullYear()
    this.doanh_thu_ke_hoach = financeInfo?.doanh_thu_ke_hoach
    this.doanh_thu_cong_ich_ke_hoach = financeInfo?.doanh_thu_cong_ich_ke_hoach
    this.doanh_thu_cong_ich_thuc_hien = financeInfo?.doanh_thu_cong_ich_thuc_hien
    this.doanh_thu_ngoai_cong_ich_ke_hoach = financeInfo?.doanh_thu_ngoai_cong_ich_ke_hoach
    this.doanh_thu_ngoai_cong_ich_thuc_hien = financeInfo?.doanh_thu_ngoai_cong_ich_thuc_hien
    this.doanh_thu_tai_chinh = financeInfo?.doanh_thu_tai_chinh
    this.thu_nhap_khac = financeInfo?.thu_nhap_khac
    this.tai_san_ngan_han = financeInfo?.tai_san_ngan_han
    this.no_ngan_han = financeInfo?.no_ngan_han
    this.no_dai_han = financeInfo?.no_dai_han
    this.von_gop_CSH_ke_hoach = financeInfo?.von_gop_CSH_ke_hoach
    this.von_gop_CSH_dau_nam = financeInfo?.von_gop_CSH_dau_nam
    this.quy_dtpt_dau_nam = financeInfo?.quy_dtpt_dau_nam
    this.von_gop_CSH_thuc_hien_dau_nam = financeInfo?.von_gop_CSH_thuc_hien_dau_nam
    this.von_gop_CSH_cuoi_nam = financeInfo?.von_gop_CSH_cuoi_nam
    this.quy_dtpt_cuoi_nam = financeInfo?.quy_dtpt_cuoi_nam
    this.von_gop_CSH_thuc_hien_cuoi_nam = financeInfo?.von_gop_CSH_thuc_hien_cuoi_nam
    this.co_tuc_ke_hoach_tong_cong_ty = financeInfo?.co_tuc_ke_hoach_tong_cong_ty
    this.co_tuc_thuc_hien_tong_cong_ty = financeInfo?.co_tuc_thuc_hien_tong_cong_ty
    this.ty_le_co_tuc_ke_hoach_tong_cong_ty = financeInfo?.ty_le_co_tuc_ke_hoach_tong_cong_ty
    this.ty_le_co_tuc_thuc_hien_tong_cong_ty = financeInfo?.ty_le_co_tuc_thuc_hien_tong_cong_ty
    this.co_tuc_ke_hoach_don_vi = financeInfo?.co_tuc_ke_hoach_don_vi
    this.co_tuc_thuc_hien_don_vi = financeInfo?.co_tuc_thuc_hien_don_vi
    this.ty_le_co_tuc_ke_hoach_don_vi = financeInfo?.ty_le_co_tuc_ke_hoach_don_vi
    this.ty_le_co_tuc_thuc_hien_don_vi = financeInfo?.ty_le_co_tuc_thuc_hien_don_vi
    this.loi_nhuan_sau_thue_ke_hoach = financeInfo?.loi_nhuan_sau_thue_ke_hoach
    this.loi_nhuan_sau_thue_thuc_hien = financeInfo?.loi_nhuan_sau_thue_thuc_hien
    this.tien_luong_nguoi_quan_ly_ke_hoach = financeInfo?.tien_luong_nguoi_quan_ly_ke_hoach
    this.tien_luong_nguoi_quan_ly_thuc_hien = financeInfo?.tien_luong_nguoi_quan_ly_thuc_hien
    this.tien_luong_nguoi_lao_dong_ke_hoach = financeInfo?.tien_luong_nguoi_lao_dong_ke_hoach
    this.tien_luong_nguoi_lao_dong_thuc_hien = financeInfo?.tien_luong_nguoi_lao_dong_thuc_hien
  }
}


export declare interface InvestmentStatusReport {
  [index: string]: unknown;
  id?: string;
  finance_info: FinanceInfo['id'] | FinanceInfo;
  von_gop_ke_hoach?: number | null;
  von_gop_nam_truoc?: number | null;
  von_gop_nam_nay?: number | null;
  ty_le_von_gop_ke_hoach?: number | null;
  ty_le_von_gop_nam_truoc?: number | null;
  ty_le_von_gop_nam_nay?: number | null;
  von_dieu_le?: number | null;
  von_chu_so_huu?: number | null;
  doanh_thu_ky_truoc?: number | null;
  doanh_thu_ky_bao_cao?: number | null;
  loi_nhuan_ky_truoc?: number | null;
  loi_nhuan_ky_bao_cao?: number | null;
  loi_nhuan_chia?: number | null;
  ty_le_loi_nhuan_chia_tren_von_dau_tu?: number | null;
  he_so_kha_nang_thanh_toan_no_den_han?: number | null;
  he_so_no_tren_von_chu_so_huu?: number | null;
}


export declare interface CompanyGradeReport {
  [index: string]: unknown;
  id?: string;
  finance_info: FinanceInfo['id'] | FinanceInfo;
  doanh_thu_ke_hoach: number | null;
  doanh_thu_thuc_hien: number | null;
  xep_loai_chi_tieu_1: string;
  loi_nhuan_sau_thue_ke_hoach: number | null;
  loi_nhuan_sau_thue_thuc_hien: number | null;
  von_csh_ke_hoach: number | null;
  von_csh_thuc_hien: number | null;
  ty_suat_loi_nhuan_ke_hoach: number | null;
  ty_suat_loi_nhuan_thuc_hien: number | null;
  xep_loai_chi_tieu_2: string;
  tai_san_ngan_han: number | null;
  no_ngan_han: number | null;
  tsnh_tren_nnh: number | null;
  no_qua_han: number | null;
  xep_loai_chi_tieu_3: string;
  xep_loai_chi_tieu_4: string;
  xep_loai_chi_tieu_5: string;
  la_doanh_nghiep_kinh_doanh: boolean | null;
  la_doanh_nghiep_cong_ich_lt_70: boolean | null;
  la_doanh_nghiep_cong_ich_gte_70: boolean | null;
  xep_loai_doanh_nghiep: string;
}

export declare interface CompanyManagerGradeReport {
  [index: string]: unknown;
  id?: string;
  finance_info: FinanceInfo['id'] | FinanceInfo;
  ty_suat_loi_nhuan_ke_hoach: number | null;
  ty_suat_loi_nhuan_thuc_hien: number | null;
  ty_suat_loi_nhuan_thuc_hien_tren_ke_hoach: number | null;
  xep_loai_doanh_nghiep: string;
  tinh_hinh_chap_hanh: string;
  xep_loai_NQL_doanh_nghiep: string;
}

export declare interface CompanyRepresentativeReport {
  [index: string]: unknown;
  id?: string;
  finance_info: FinanceInfo['id'] | FinanceInfo;
  nguoi_dai_dien: string;
  chuc_danh: string;
  ty_le_von_gop: number | null;
  xep_loai_doanh_nghiep_theo_gstc: string;
  ty_suat_loi_nhuan_thuc_hien_tren_ke_hoach: number | null;
  ty_le_co_tuc: number | null;
  so_tien_co_tuc: number | null;
  chap_hanh_phap_luat: string;
  pham_chat_dao_duc: string;
  xep_loai_doanh_nghiep_theo_qc: string;
  xep_loai_NDD_doanh_nghiep: string;
}

export declare interface CompanySummaryReport {
  [index: string]: unknown;
  id?: string;
  finance_info: FinanceInfo['id'] | FinanceInfo;
  doanh_thu_cong_ich_ke_hoach: number | null;
  doanh_thu_cong_ich_thuc_hien: number | null;
  doanh_thu_cong_ich_kh_chia_th: number | null;
  doanh_thu_ngoai_cong_ich_ke_hoach: number | null;
  doanh_thu_ngoai_cong_ich_thuc_hien: number | null;
  doanh_thu_ngoai_cong_ich_kh_chia_th: number | null;
  loi_nhuan_ke_hoach: number | null;
  loi_nhuan_thuc_hien: number | null;
  loi_nhuan_kh_chia_th: number | null;
  tien_luong_nguoi_quan_ly_ke_hoach: number | null;
  tien_luong_nguoi_quan_ly_thuc_hien: number | null;
  tien_luong_nguoi_quan_ly_kh_chia_th: number | null;
  tien_luong_nguoi_lao_dong_ke_hoach: number | null;
  tien_luong_nguoi_lao_dong_thuc_hien: number | null;
  tien_luong_nguoi_lao_dong_kh_chia_th: number | null;
  ty_le_co_tuc_tong_cong_ty: number | null;
  ty_le_co_tuc_tong_don_vi: number | null;
  co_tuc_ke_hoach_tong_cong_ty: number | null;
  co_tuc_thuc_hien_tong_cong_ty: number | null;
  co_tuc_kh_chia_th_tong_cong_ty: number | null;
  co_tuc_ke_hoach_don_vi: number | null;
  co_tuc_thuc_hien_don_vi: number | null;
  co_tuc_kh_chia_th_don_vi: number | null;
}

export declare interface RecentReport {
  [index: string]: unknown;
  id: string;
  file_name: string;
  created_at: string;
}

export class User {
  [index: string]: unknown;
  id: string;
  email: string;
  fullname: string;
  date_joined: string;
  last_login: string | null;
  is_superuser: boolean;
  is_staff: boolean;

  constructor (user?: User) {
    this.id = user?.id || ''
    this.email = user?.email || ''
    this.fullname = user?.fullname || ''
    this.date_joined = user?.date_joined || ''
    this.last_login = user?.last_login || null
    this.is_superuser = user?.is_superuser || false
    this.is_staff = user?.is_staff || false
  }
}
